import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import Image from 'app/Components/Shared/Image/image';
const Main = (props) => {
  useEffect(() => {
    //------------- Credit Gured -------------
    const query = new URLSearchParams(window.location.search);
    const paymentResponse = query.get('paymentResponse');

    if (paymentResponse == 'success') {
      const txId = query.get('txId');
      const selectedId = query.get('personalId');

      pageData = {status: 'success', token: txId, personalId: selectedId};

      parent.postMessage(pageData, '*');
    }

    if (paymentResponse == 'error') {
      var pageData = {status: 'error'};
      parent.postMessage(pageData, '*');
    }
  }, []);

  return (
    <div className='credit-guard-iframe'>
      <div className='pending-div__spinner-wrap'>
        <Image src={require('./images/loading.svg')} alt='' className='pending-div__spinner' width={56} height={56} />
      </div>
      <div>הכרטיס בבדיקה</div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {form: state.creditGaurd};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Main);
